import React, { useMemo, useRef, useState } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCHookToast, RCCInput, RCCServicesApi, RCCTooltip, RCCSelectOptionsCard } from "react-common-components";
import { useForm } from "react-hook-form";
import FiltersContainer from "src/components/FiltersContainer";
import Loader from "src/components/Loader";
import OrgChart from "src/components/OrgChart";
import CheckInModal from "src/components/OrgChart/checkIn";
import { IDataSource } from "src/components/OrgChart/interface";
import KeyResultsModal from "src/components/OrgChart/keyResults";
import PageTitle from "src/components/PageTitle";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import IOrgChartKeyResultsRef from "src/components/OrgChart/keyResults/interface";
import IOrgChartObjectivesRef from "src/components/OrgChart/objectives/interface";
import ObjectivesModal from "src/components/OrgChart/objectives";
import AttachmentsModal from "src/components/OrgChart/attachments";
import CommentsModal from "src/components/OrgChart/comments";
import IOrgChartCheckInRef from "src/components/OrgChart/checkIn/interface";
import IOrgChartCommentsRef from "src/components/OrgChart/comments/interface";
import IOrgChartAttachmentsRef from "src/components/OrgChart/attachments/interface";
import LovUsers from "src/components/Lov/Users";
import LovSectors from "src/components/Lov/Sectors";
import DateTimePickerRange from "src/components/DateTimePickerRange";
import formatDate from "src/utils/formatDate";
import extractSingleValueFromArrayOfObject from "src/utils/extractSingleValueFromArrayOfObject";
import IOrgChartMissionAndPremisesRef from "src/components/OrgChart/missionAndPremises/interface";
import MissionAndPremisesModal from "src/components/OrgChart/missionAndPremises";
import { IRefFiltersTagsContainer, TagsTypes } from "src/components/FiltersTagsContainer/interface";
import FiltersTagsContainer from "src/components/FiltersTagsContainer";
import { getLocalStorage, setLocalStorage } from "src/utils/localStorage";
import { useAuth } from "src/context/Auth/context";
import { getCookie, setCookie } from "src/utils/cookies";

import useEffectSkipInitialRender from "src/hooks/useEffectSkipInitialRender";
import ButtonExpandGroupers from "src/components/ButtonExpandGroupers";
import ModalIniciatives from "src/components/ModalIniciatives";
import { IRefIniciativeModals } from "src/components/ModalIniciatives/interface";
import Select from "src/components/Select";
import { useLocation, useParams } from "react-router-dom";
import getUrlSearchParams from "src/utils/getUrlSearchParams";
import putUrlSearchParams from "src/utils/putUrlSearchParams";
import LovGrouperOKRs from "src/components/Lov/GrouperOKRs";
import AppIcons from "src/components/AppIcons";
import CheckPermission from "src/components/CheckPermission";
import { PermissionEnum } from "src/context/Auth/interface";
import periodsObjectives from "src/components/OrgChart/objectives/periodsObjectives";
import stringToDate from "src/utils/stringToDate";
import ScreenStandardGroup from "src/Interfaces/screenStandardGroup";
import IGroupersOKR, { GroupersOKR, IFiltersOKR, IGroupersSelect } from "./interface";
import { HierarchyOrgChartContext } from "./hierarchyOrgChart";
import GrouperOfOkrs from "./grouperOfOKRs";

const OKR: React.FC = () => {
	const params = useParams<{
        okrId: string;
    }>();

	const query = useLocation();
	const objQueryParams = getUrlSearchParams(query.search);
		
	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	const { user } = useAuth();

	const keyResultsRef = useRef<IOrgChartKeyResultsRef>(null);
	const orgChartsRef = useRef<IOrgChartObjectivesRef>(null);
	const checkInRef = useRef<IOrgChartCheckInRef>(null);
	const commentsRef = useRef<IOrgChartCommentsRef>(null);
	const attachmentsRef = useRef<IOrgChartAttachmentsRef>(null);
	const missionAndPromisesRef = useRef<IOrgChartMissionAndPremisesRef>(null);
	const refModalIniciatives = useRef<IRefIniciativeModals>(null);
	
	const [loading, setLoading] = useState(true);
	const [errorLoadingGroupers, setErrorLoadingGroupers] = useState(false);

	const [view, setView] = useState<"list" | "hierarchy">("list");

	const [layoutList, setLayoutList] = useState<"card" | "list">(getLocalStorage(`OKRScreenLayoutList-${user.efa005Id}`) === "card" ? "card" : "list");
	
	const filtersTagsRef = useRef<IRefFiltersTagsContainer>(null);
	const [showTagsFilters, setShowTagsFilters] = useState(false);
	const [showFilters, setShowFilters] = useState(false);
	const [myOKRS, setMyOKRS] = useState(false);
	const [filters, setFilters] = useState<IFiltersOKR>({ 
		f: objQueryParams?.f || "", 
		responsible: objQueryParams?.responsible || "",
		authority: objQueryParams?.authority || "",
		sector: objQueryParams?.sector || "",
		tags: objQueryParams?.tags || "",
		startDate: objQueryParams?.startDate ? stringToDate(objQueryParams.startDate) : null,
		endDate: objQueryParams?.endDate ? stringToDate(objQueryParams.endDate) : null,
		level: objQueryParams?.level || "",
		okrId: params.okrId && params.okrId.length > 0 ? params.okrId : ""
	});
	const { handleSubmit : handleSubmitFilters, register : registerFilters, control: controlFilters, reset: resetFilters, setValue: setValueFilters } = useForm();
	const submitFilters = (data: any) => {
		const dataForm = data;

		dataForm.okrId = "";

		if(data.tags)
			dataForm.tags = extractSingleValueFromArrayOfObject("value", data.tags)?.toString();
		if(typeof data.responsible === "object")
			dataForm.responsible = data.responsible.value;
		if(typeof data.authority === "object")
			dataForm.authority = data.authority.value;
		if(typeof data.sector === "object")
			dataForm.sector = data.sector.value;
		if(typeof data.level === "object")
			dataForm.level = data.level.value;

		if(myOKRS)
			dataForm.responsible = user.efa005Id.toString();
			
		putUrlSearchParams(dataForm);
		setFilters(dataForm);
	};
	const submitFiltersTags = async () => {
		setFilters((prevState) => {
			const updateState = {...prevState};
			updateState.tags = filtersTagsRef.current?.response || "";
			return updateState;
		});
	};
	
	const buttonSubmitFormGroupersRef = useRef<HTMLButtonElement>(null);
	const { handleSubmit : handleSubmitGroupers, control: controlGroupers } = useForm();
	const [defaultGrouper, setDefaultGrouper] = useState<GroupersOKR | undefined>(getCookie(ScreenStandardGroup.OKR) as GroupersOKR);
	const [groupersSelect, setGroupersSelect] = useState<IGroupersSelect>({
		group: objQueryParams?.group as GroupersOKR || defaultGrouper || GroupersOKR.LEVEL,
		list: objQueryParams?.list === "T" ?  "T" : "P"
	});

	const [groupers, setGroupers] = useState<IGroupersOKR[]>([]);

	const submitGroupers = async (data: any) => {
		setGroupersSelect({
			...data
		});
	};

	const loadGroupers = async () => {
		try{
			setLoading(true);
			setErrorLoadingGroupers(false);

			const {data} = await RCCServicesApi.getRequest({
				method: "OKR/ListGroupers",
				urlParameters: {
					...groupersSelect,
					f: filters.f || "",
					responsible: filters.responsible || "",
					authority: filters.authority || "",
					sector: filters.sector || "",
					tags: filters.tags || "",
					startDate: filters.startDate ? formatDate(filters.startDate) : "",
					endDate: filters.endDate ? formatDate(filters.endDate) : "",
					level: filters.level || "",
					okrId: filters.okrId || ""
				}
			});

			let groupersFromDB: IGroupersOKR[] = data;
			
			if(groupersSelect.group === GroupersOKR.LEVEL){
				groupersFromDB = groupersFromDB.map((grouperDB) => {
					const groupDB = grouperDB;
					if(grouperDB.id === 1){
						groupDB.title = translate("Organizacional");
						return groupDB;
					}
					if(grouperDB.id === 2){
						groupDB.title = translate("Equipe");
						return groupDB;
					}
					groupDB.title = translate("Individual");
					return groupDB;		
				});
			}
			
			if(groupersSelect.group === GroupersOKR.PERIOD){
				const indexToUpdate = groupersFromDB.findIndex((grouperDB) => !grouperDB.title || grouperDB.title === "");
				if(indexToUpdate > -1)
					groupersFromDB[indexToUpdate].title = translate("Sem período"); 
			}
			
			if(groupersSelect.group === GroupersOKR.SECTOR){
				const indexToUpdate = groupersFromDB.findIndex((grouperDB) => !grouperDB.title || grouperDB.title === "");
				if(indexToUpdate > -1)
					groupersFromDB[indexToUpdate].title = translate("Sem setor"); 
			}
					
			setGroupers(groupersFromDB);

			setLoading(false);
		}catch(err){
			setErrorLoadingGroupers(true);
			standardErrorMessages(err, translate("Erro ao carregar os agrupadores"), addToast);
			setLoading(false);
		}
	};

	const setAsDefaultGrouper = async () => {
		const {group} = groupersSelect;
		try{
			await RCCServicesApi.postRequest({
				method: "OKR/SetDefaultGrouper",
				body: {
					group
				}
			});
			setDefaultGrouper(group);
			setCookie(ScreenStandardGroup.OKR, group);
			addToast({
				color: "green",
				description: translate("Agrupador padrão atualizado com sucesso"),
				title: translate("Sucesso")
			});
		}catch(err){
			standardErrorMessages(err, translate("Erro ao alterar agrupador padrão"), addToast);
		}

	};

	const callbackOnAdd = () => {
		loadGroupers();
	};

	useEffectSkipInitialRender(() => {
		loadGroupers();
	}, [groupersSelect, filters]);

	const onViewHierarchy = async (id: number) => {
		setView("hierarchy");
		try{
			setLoadingHierarchy(true);
			setErrorLoadingHierarchy(false);
			const {data} = await RCCServicesApi.getRequest({
				method: "OKR/ViewHierarchy",
				urlParameters: {
					id
				}
			});
			setOrgChartDataSource(data);
			setLoadingHierarchy(false);
		}catch(err){
			setLoadingHierarchy(false);
			setErrorLoadingHierarchy(true);
			standardErrorMessages(err, translate("Erro ao carregar a hierarquia"), addToast);
		}
	};

	const GroupersAndList = useMemo(() => (
		<>
			{loading ? (
				<Loader />
			) : (
				<>
					{errorLoadingGroupers ? (
						<RCCAlert 
							title={translate("Atenção")}
							description={translate("Erro ao tentar encontrar resultados para esta pesquisa")}
						/>
					): (
						<>
							{groupers.length === 0 ? (
								<RCCAlert 
									title={translate("Atenção")}
									description={translate("Nenhum agrupador encontrado")}
								/>
							): (
								<>
									{groupers.map((grouper) => (
										<GrouperOfOkrs 
											key={`${grouper.id}-grouper-okrs`}
											grouper={grouper}
											layoutList={layoutList}
											onViewHierarchy={onViewHierarchy}
											filters={filters}
											groupersSelect={groupersSelect}
											openModalAddOrChange={orgChartsRef.current?.openModalAddOrChange}
											openModalDelete={orgChartsRef.current?.openModalDelete}
											openModalOKRComments={commentsRef.current?.openModalOKRComments}
											openModalOKRAttachments={attachmentsRef.current?.openModalOKRAttachments}
										/>
									))}
								</>
							)}
						</>
					)}
				</>
			)}	
		</>
	), [groupers, loading, errorLoadingGroupers, layoutList]);

	const [zoom, setZoom] = useState(false);
	const [loadingHierarchy, setLoadingHierarchy] = useState(false);
	const [errorLoadingHierarchy, setErrorLoadingHierarchy] = useState(false);
	const [orgChartDataSource, setOrgChartDataSource] = useState<IDataSource>({} as IDataSource);
	const toggleZoom = () => setZoom((prevState) => !prevState);

	const recursivelyAddChildrenHierarchy = (state: IDataSource, data: IDataSource, id: number) => {
		if(state.id === id){
			const found = state.children.some((x) => x.id === data.id);
			if(!found)
				state.children.push(data);

			return state;
		}	
		state.children.forEach((child) => {
			recursivelyAddChildrenHierarchy(child, data, id);
		});

		return state;
	};

	const callbackOnAddOKRHierarchy = async (id: number) => {
		if(!id)
			return;
		setErrorLoadingHierarchy(false);
		try{
			setLoadingHierarchy(true);
			const {data} = await RCCServicesApi.getRequest({
				method: "OKR/GetLastChildrenAddedOnOKRHierarchy",
				urlParameters: {
					id
				}
			});	
			if(data && data !== null){
				setOrgChartDataSource((prevState) => {
					const newState = recursivelyAddChildrenHierarchy(prevState, data, id);
					return newState;
				});			
			}
			setLoadingHierarchy(false);
		}catch(err){
			setLoadingHierarchy(true);
			setErrorLoadingHierarchy(true);
			standardErrorMessages(err, translate("Erro ao atualizar OKR, favor atualizar a pagina"), addToast);
		}
	};

	const callbackOnChangeOKRHierarchy = async (id: number) => {
		
		if(!id)
			return;

		setErrorLoadingHierarchy(false);
		try{
			setLoadingHierarchy(true);
			const {data} = await RCCServicesApi.getRequest({
				method: "OKR/InfosOfOKRForHierarchy",
				urlParameters: {
					id
				}
			});
			
			if(data === null){
				setLoadingHierarchy(false);
				throw new Error(translate("Erro ao atualizar OKR, favor atualizar a pagina"));
			}
			
				
			if(orgChartDataSource.id === id){
				setOrgChartDataSource((prevState) => ({ ...data, children: prevState.children}));
				setLoadingHierarchy(false);
				return;
			}

			const editOrgChartState = orgChartDataSource;

			const editFromTree = (root: IDataSource, parent?: IDataSource, idx?: number) => {
				if (root.id === id) {
					if (parent && (idx || idx === 0)) {
						const {children} = parent.children[idx];
						parent.children.splice(idx, 1, {
							...data,
							children
						});
					}
					else return null;
				}
							
				root.children.forEach((child, i) => {
					editFromTree(child, root, i);
				});

				return editOrgChartState;
			};

			editFromTree(editOrgChartState);
			setOrgChartDataSource(editOrgChartState);
			setLoadingHierarchy(false);
		}catch(err){
			setErrorLoadingHierarchy(true);
			setLoadingHierarchy(false);
			standardErrorMessages(err, translate("Erro ao atualizar OKR, favor atualizar a pagina"), addToast);
		}
	};

	const callbackOnDeleteOKRHierarchy = (id: number) => {
		if(!id)
			return;

		const editOrgChartState = orgChartDataSource;

		const removeFromTree = (root: IDataSource, parent?: IDataSource, idx?: number) => {
			if (root.id === id) {
			  if (parent && idx) {
					parent.children.splice(idx, 1);
			  }
			  else return null;
			}
						
			root.children.forEach((child, i) => {
				removeFromTree(child, root, i);
			});

			return editOrgChartState;
		};

		
		if(orgChartDataSource.id === id){
			setView("list");
			return;
		}

		removeFromTree(editOrgChartState);

		if(!editOrgChartState || editOrgChartState === null){
			setView("list");
			return;
		}

		setOrgChartDataSource(editOrgChartState);
	};

	return(
		<>
			<RCCGrid
				container
				item
				direction="column"
			>
				{view === "list" ? (
					<>
						{/* Header -> Results + Buttons */}
						<PageTitle
							title="OKR"
							icon={() => <AppIcons name="strategicPlanning" />}
						>
							<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
								<RCCTooltip
									text={translate("Novo OKR")}
									color="purple"
								>
									<RCCButton
										icon={{name: "plus", color: "#FFF", size: 18}}
										color="purple"
										layout="isRounded"
										onClick={() => { orgChartsRef.current?.openModalAddOrChange(undefined, undefined, () => callbackOnAdd() ); }}
										size="md"
									/>
								</RCCTooltip>
							</CheckPermission>
							<ButtonExpandGroupers />
							<RCCTooltip
								text={layoutList === "card" ? translate("Alterar para lista") : translate("Alterar para cards")}
								color="grey"
							>
								<RCCButton
									icon={{
										name: layoutList === "card" ? "list" : "table", 
										color: "#FFF", 
										size: 16
									}}
									color="grey"
									layout="isRounded"
									size="md"
									onClick={() => {
										if(layoutList === "card"){
											setLayoutList("list");
											setLocalStorage(`OKRScreenLayoutList-${user.efa005Id}`, "list");
											return;
										}
										setLocalStorage(`OKRScreenLayoutList-${user.efa005Id}`, "card");
										setLayoutList("card");
									}}
								/>
							</RCCTooltip>
							<RCCTooltip
								text={`${translate("Filtros")} Tags`}
								color={showTagsFilters || filters.tags ? "blue" : "grey"}
							>
								<RCCButton
									icon={{name: "tags", color: "#FFF", size: 16}}
									color={showTagsFilters || filters.tags ? "blue" : "grey"}
									layout="isRounded"
									size="md"
									onClick={() => setShowTagsFilters((prevState) => !prevState)}
								/>
							</RCCTooltip>
							<RCCTooltip
								text={translate("Filtros")}
								color={
									showFilters || 
									filters.f || 
									filters.authority || 
									filters.responsible || 
									filters.sector || 
									filters.startDate || 
									filters.endDate ? "blue" : "grey"
								}
							>
								<RCCButton
									icon={{name: "filter", color: "#FFF", size: 16}}
									color={
										showFilters || 
										filters.f || 
										filters.authority || 
										filters.responsible || 
										filters.sector || 
										filters.startDate || 
										filters.endDate ? "blue" : "grey"
									}
									layout="isRounded"
									size="md"
									onClick={() => setShowFilters((prevState) => !prevState)}
								/>
							</RCCTooltip>
						</PageTitle>
							
						{/* Filters */}
						<FiltersContainer
							showFilters={showFilters}
							onSubmitFilters={handleSubmitFilters(submitFilters)}
							resetFilters={() => resetFilters({ 
								f: "", 
								responsible: { value: "", label: ""},
								authority: { value: "", label: ""},
								sector: { value: "", label: ""},
								startDate: null,
								endDate: null,
								level: { value: "", label: ""}
							})}
						>
							<RCCGrid
								container
								item
								spacing={1}
							>
								<RCCGrid
									container 
									item
									xs={12}
									sm={6}
									md={4}
									lg={4}
								>
									<DateTimePickerRange
										control={controlFilters}
										label={translate("Período")}
										labelSeparator={translate("até")}
										nameInit = "startDate"
										nameEnd = "endDate"
										defaultValueEnd={filters.endDate}
										defaultValueInit={filters.startDate}
										type="datePicker"
										periods={periodsObjectives(translate)}
										setValue={setValueFilters}
									/>
								</RCCGrid>
								<RCCGrid
									container 
									item
									xs={12}
									sm={6}
									md={4}
									lg={4}
								>
									<LovUsers 
										control={controlFilters}
										name="authority"
										label={translate("Autoridade")}
										defaultValue={filters.authority}
										isClearable
									/>
								</RCCGrid>
								<RCCGrid
									container 
									item
									xs={12}
									sm={6}
									md={4}
									lg={4}
								>
									<LovUsers 
										control={controlFilters}
										name="responsible"
										label={translate("Responsável")}
										defaultValue={filters.responsible}
										disabled={myOKRS}
										isClearable
									/>
								</RCCGrid>
							</RCCGrid>

							<RCCGrid
								container
								item
								spacing={1}
								style={{marginBottom: "1.5rem"}}
							>
								<RCCGrid
									container 
									item
									xs={12}
									sm={6}
									md={4}
									lg={4}
								>
									<LovSectors 
										control={controlFilters}
										name="sector"
										label={translate("Setor")}
										defaultValue={filters.sector}
										isClearable
									/>
								</RCCGrid>
								
								<RCCGrid
									container 
									item
									xs={12}
									sm={6}
									md={4}
									lg={4}
								>
									<Select
										name="level" 
										label={translate("Nível")}
										control={controlFilters}
										defaultValue={filters.level}
										isClearable
										options={[{
											label: translate("Organizacional"),
											value: "1"
										},{
											label: translate("Equipe"),
											value: "2"
										},{
											label: translate("Individual"),
											value: "3"
										}]}
									/>
								</RCCGrid>

								<RCCGrid
									container 
									item
									xs={12}
									sm={6}
									md={4}
									lg={4}
								>
									<RCCInput
										name="f" 
										label={translate("Pesquisar")}
										register={registerFilters}
										defaultValue={filters.f}
									/>
								</RCCGrid>
							</RCCGrid>

						</FiltersContainer>

						{/* Filters Tags */}
						<FiltersTagsContainer 
							ref={filtersTagsRef}
							onSubmitFilters={submitFiltersTags}
							tagType={TagsTypes.OKR}
							showFilters={showTagsFilters}
						/>	

						<form onSubmit={handleSubmitGroupers(submitGroupers)} style={{marginBottom: "1rem", minHeight: "60px"}}>
							<RCCGrid
								container
								item
								spacing={1}
							>
								<RCCGrid
									container
									item
									xs={12}
									sm={6}
									md={4}
									lg={3}
									alignItems="baseline"
								>
									<LovGrouperOKRs 
										control={controlGroupers}
										name="group"
										defaultValue={groupersSelect.group}
										onChangeCapture={() => buttonSubmitFormGroupersRef.current?.click()}
										styleInline="width: auto; flex: 1;"
									/>
									<RCCTooltip
										color="grey"
										text={translate("Definir como agrupador padrão")}
									>
										<RCCButton 
											color="transparent"
											icon={{
												name: "checkBookmark",
												color: "var(--grey)"
											}}
											onClick={setAsDefaultGrouper}
										/>
									</RCCTooltip>
								</RCCGrid>
								<RCCGrid
									container
									item
									xs={12}
									sm={6}
									md={4}
									lg={3}
								>
									<Select 
										control={controlGroupers}
										name="list"
										label={translate("Listar OKR's")}
										options={[
											{ value: "T", label: `${translate("Todos")}` },
											{ value: "P", label: `${translate("Principais")}` }
										]}
										defaultValue={groupersSelect.list}
										onChangeCapture={() => buttonSubmitFormGroupersRef.current?.click()}
									/>
								</RCCGrid>

								<RCCGrid
									container
									item
									xs={12}
									md={4}
									lg={6}
									justifyContent="flex-end"
								>
									<RCCSelectOptionsCard
										defaultValue={myOKRS ? "S" : "N"}
										options={[{
											value: "N",
											label: translate("Todos OKRs")
										},{
											value: "S",
											label: translate("Meus OKRs")
										}]}
										label="&nbsp;"
										onChange={(e) => {
											setValueFilters("responsible", { value: "", label: ""});
											if(e === "S"){
												setMyOKRS(true);
												setFilters({
													...filters,
													responsible: user.efa005Id.toString()
												});
												return;
											}
											setMyOKRS(false);
											setFilters({
												...filters,
												responsible: ""
											});
										}}
									/>
								</RCCGrid>

							</RCCGrid>
							<button 
								aria-label="Submit Form"
								ref={buttonSubmitFormGroupersRef}
								type="submit" 
								style={{ display: "none" }}
							></button>
						</form>

						{GroupersAndList}
					</>
				): (
					<>
						{/* Header -> Results + Buttons */}
						<PageTitle
							title={translate("Hierarquia")}
							icon={() => <AppIcons name="strategicPlanning" />}
						>
							<RCCTooltip
								text={!zoom ? translate("Ligar Zoom") : translate("Desligar Zoom")}
								color="purple"
							>
								<RCCButton
									icon={{name: !zoom ? "searchPlus" : "searchMinus", color: "#FFF", size: 18}}
									color="purple"
									layout="isRounded"
									onClick={toggleZoom}
									size="md"
								/>
							</RCCTooltip>
							<RCCTooltip 
								text={translate("Comprimir todos resultados chave")}
								color="grey"
							>
								
								<RCCButton
									icon={{name: "compress", color: "#FFF", size: 18}}
									color="grey"
									layout="isRounded"
									onClick={() => {
										const hierarchyKRsContainer = document.querySelectorAll(".keyResultsOfObjectiveInHierarchy_score_okr");
										const {length} = hierarchyKRsContainer;
			
										if(length === 0)
											return;
			
										for(let i = 0; i < length; i += 1){
											if(hierarchyKRsContainer[i] === undefined)
												return;
											const htmlElement = hierarchyKRsContainer[i] as HTMLElement;
											htmlElement.style.display = "none";
										}
									}}
									size="md"
								/>
							</RCCTooltip>
							<RCCTooltip 
								text={translate("Expandir todos resultados chave")}
								color="grey"
							>
								<RCCButton
									icon={{name: "expand", color: "#FFF", size: 18}}
									color="grey"
									layout="isRounded"
									onClick={() => {
										const hierarchyKRsContainer = document.querySelectorAll(".keyResultsOfObjectiveInHierarchy_score_okr");
										const {length} = hierarchyKRsContainer;
			
										if(length === 0)
											return;
			
										for(let i = 0; i < length; i += 1){
											if(hierarchyKRsContainer[i] === undefined)
												return;
											const htmlElement = hierarchyKRsContainer[i] as HTMLElement;
											htmlElement.style.display = "flex";
										}
									}}
									size="md"
								/>
							</RCCTooltip>
							<RCCTooltip
								text={translate("Voltar")}
								color="grey"
							>
								<RCCButton
									icon={{name: "arrowBack", color: "#FFF", size: 16}}
									color="grey"
									layout="isRounded"
									size="md"
									onClick={() => setView("list")}
								/>
							</RCCTooltip>
						</PageTitle>
					
						<HierarchyOrgChartContext.Provider
							value={{
								callbackOnAddOKRHierarchy,
								callbackOnChangeOKRHierarchy,
								callbackOnDeleteOKRHierarchy,
								openModalAddOrChange: orgChartsRef.current?.openModalAddOrChange,
								openModalAddOrChangeKr: keyResultsRef.current?.openModalAddOrChangeKr,
								openModalDelete: orgChartsRef.current?.openModalDelete,
								openModalPerformCheckIn: checkInRef.current?.openModalPerformCheckIn,
								openModalOKRAttachments: attachmentsRef.current?.openModalOKRAttachments,
								openModalOKRComments: commentsRef.current?.openModalOKRComments,
								openModalOKRMissionAndPremises: missionAndPromisesRef.current?.openModalMissionAndPremises,
								openModalIniciatives: refModalIniciatives.current?.openModalIniciative
							}}
						>
							{loadingHierarchy ? (
								<Loader />
							) : (
								<>
									{errorLoadingHierarchy ? (
										<RCCAlert 
											title={translate("Atenção")}
											description={translate("Erro ao tentar encontrar resultados para esta pesquisa")}
										/>
									): (
										<OrgChart 
											pan 
											zoom={zoom}
											dataSource={orgChartDataSource}
										/> 

									)}
								</>
							)}
						</HierarchyOrgChartContext.Provider>
					</>
				)}
			
			</RCCGrid>

			<ObjectivesModal 
				ref={orgChartsRef} 
				openModalAddOrChangeKr={keyResultsRef.current?.openModalAddOrChangeKr} 
				openModalDeleteKr={keyResultsRef.current?.openModalDeleteKr} 
				openModalPerformCheckIn={checkInRef.current?.openModalPerformCheckIn} 
				openModalOKRComments={commentsRef.current?.openModalOKRComments}
				openModalOKRAttachments={attachmentsRef.current?.openModalOKRAttachments}
			/>

			<KeyResultsModal ref={keyResultsRef}/>

			<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
				<CheckInModal ref={checkInRef} />
			</CheckPermission>

			<CommentsModal ref={commentsRef} />

			<AttachmentsModal ref={attachmentsRef} />

			<MissionAndPremisesModal ref={missionAndPromisesRef} />

			<ModalIniciatives ref={refModalIniciatives} onCallbackIniciatives={() => {}} />
		</>
	);};

export default OKR;
